var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",style:({ 'background-image': `url("${_vm.bannerImg || _vm.defaultBannerImg}")` }),attrs:{"aria-hidden":"true"}},[_c('ChangeBtn',{staticClass:"banner-img-change-btn",attrs:{"has-editor":true,"type":"BannerImage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }